import { Loader2 } from "lucide-react";

export function Loader({ label = "Loading…" }) {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-[#6a6d70]">
      <Loader2 className="animate-spin text-[#0a6ed1]" size={32} />
      <p className="mt-3 text-xs uppercase tracking-wider">{label}</p>
    </div>
  );
}
